import { reportEntryLog } from '@xt/client/utils/log'
import { TemplateFive, TemplateTen, TemplateThree, TemplateTwenty } from './template'
import { formatBiShan, formatClasshourUIStatus } from './template/utils'
import type { ClasshourItem } from '@xt/client/entities/course-v2/types.d'
import type { Template, BaseTemplate, Classhour } from './types'

export class ClasshourMapUtils {
  /**
   * 接口地图页课时数据列表
   */
  private classhourList: ClasshourItem[]
  /**
   * 头部课程(开学见面)是否已经发布
   */
  private withStartCourse: boolean
  /**
   * 尾部课程(小灶课)是否已经发布
   */
  private withEndCourse: boolean
  /**
   * 模版数量
   */
  public template: Template
  /**
   * 当前真实的课程进度 取值 0 - template
   */
  public taskSchedule: number
  /**
   * 展示学习回顾
   */
  public showReview: boolean
  /**
   * 展示开课前请准备 与 学习回顾位置互斥
   */
  public showPrepare: boolean
  /**
   * 每个模版的具体实现类
   */
  private instance: BaseTemplate
  /**
   * 当前真实的课程进度索引，与taskSchedule相比 taskSchedule不会返回小灶课尾部课程的索引
   * 模版3  realCurrent: 0 - 4
   * 模版5  realCurrent: 0 - 6
   * 模版10 realCurrent: 0 - 11
   * 模版20  realCurrent: 0 - 21
   */
  private realCurrent: number

  /**
   *
   * @param list
   * @param taskSchedule 当前的课程进度 0 - 3 | 0 - 5 | 0 - 10 | 0 - 20
   * @param showReview 展示学习回顾
   */
  constructor(list: ClasshourItem[], taskSchedule: number, options: { showReview: boolean; showPrepare: boolean }) {
    const result: ClasshourItem[] = []
    this.template = (list.length - 2) as Template
    this.taskSchedule = taskSchedule
    //  当前课程的真实进度 如果课程本身没发布 认为进度是0
    this.realCurrent = Math.max(
      0,
      list.findLastIndex(item => item.publishStatus === 1)
    )
    this.showReview = options.showReview
    this.showPrepare = options.showPrepare

    if (taskSchedule > this.template || taskSchedule < 0) {
      reportEntryLog('classhour-map.ctro.task-schedule-error', {
        taskSchedule: taskSchedule,
        template: this.template,
        ids: list.map(i => i.id)
      })
    }

    if (![3, 5, 10, 20].includes(this.template)) {
      reportEntryLog('classhour-map.ctro.template-error', {
        template: this.template,
        ids: list.map(i => i.id)
      })
      console.error(`课时数据与模版不匹配, 当前数据的模版数为 ${list.length - 2}`)
      throw new Error('课时数据与模版不匹配')
    }

    /**
     * 格式化课时数据
     * 头部课程(开学见面)和尾部课程(小灶课) 根据后台是否发布而定
     */
    list.map((item, index) => {
      if (index === 0) {
        this.withStartCourse = item.publishStatus === 1
      } else if (index === list.length - 1) {
        this.withEndCourse = item.publishStatus === 1
      }

      result.push(item)
    })

    this.classhourList = result

    const instanceOptions = {
      taskSchedule: this.taskSchedule,
      showReview: this.showReview,
      showPrepare: this.showPrepare,
      withStartCourse: this.withStartCourse,
      withEndCourse: this.withEndCourse,
      realCurrent: this.realCurrent
    }

    switch (this.template) {
      case 3:
        this.instance = new TemplateThree(instanceOptions)
        break
      case 5:
        this.instance = new TemplateFive(instanceOptions)
        break
      case 10:
        this.instance = new TemplateTen(instanceOptions)
        break
      case 20:
        this.instance = new TemplateTwenty(instanceOptions)
        break
    }
  }

  public getTemplateSize() {
    return this.instance.getTemplateSize()
  }

  public getTopMaterialConfigList() {
    return this.instance.getTopMaterialConfigList()
  }

  public getBottomMaterialConfigList() {
    return this.instance.getBottomMaterialConfigList()
  }

  public getClasshourConfigList(): Array<Classhour> {
    return this.classhourList.map((item, index) => {
      return {
        visible: index === 0 ? this.withStartCourse : index === this.classhourList.length - 1 ? this.withEndCourse : true,
        cover: item.coverUrl,
        classhourId: item.id,
        title: item.name,
        uiStatus: formatClasshourUIStatus(item),
        bishanList: formatBiShan(item),
        publishStatus: item.publishStatus,
        ...this.instance.getClasshourLayoutInfo(item, index)
      } satisfies Classhour
    })
  }
}
